export const isMobile = window.innerHeight <= 812 && window.innerWidth <= 812;
export const smallScreenSize =
  window.innerHeight <= 768 || window.innerWidth <= 1024;
